import * as React from "react";
function SvgIcTableColumnCategoricalHidden(
  props: React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 13v4h7v-4H2zm6 3H3v-2h5v2zm-6 2v4h7v-4H2zm6 3H3v-2h5v2zM3.875 4l-1.25-1H22v4H7.625l-1.25-1H21V4H3.875zm18.612 10.993a.62.62 0 01-.138.448l-1.641 2.026-.77-.616 1.392-1.737-5.098-4.097-3.157.343-.928-.742a.633.633 0 01.413-.208L16.338 10l.192.015.212.13 5.674 4.561.071.288zm-8.14-2.736A.987.987 0 0115 12a1 1 0 011 1c0 .179-.06.336-.144.479l-1.51-1.222zM2.162 3.68l-.112.14L2 3.78v.102l-.438.547.438.35V7h2.776l1.25 1H2v4h7v-1.621l3.205 2.564.204 1.88 5.738 4.842.107.08.213.067a.576.576 0 00.142-.001l.254-.067.725-.895 1.715 1.373.509-.636L2.162 3.68zM3 6v-.42l.526.42H3zm5 5H3V9h4.276L8 9.579V11zm10.489 7.657l-5.102-4.097-.08-.735 5.517 4.414-.335.418z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcTableColumnCategoricalHidden;
